import React from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

export default function Register() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (values) => {};
  return (
    <>
      <div className="container">
        <div className="row justify-content-center mt-5 shadow">
          <div className="text-heading">
            <p className="text-danger mb-4 fs-3">Register Here</p>
          </div>
          <div className="col-md-6">
            <form
              className="text-center  p-4 form-group"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="form-group">
                <label for="fname">First Name</label>
                <input
                  type="firstName"
                  class="form-control light-bg"
                  id="firstName"
                  {...register("firstName", {
                    required: "First Name is required",
                    pattern: {
                      value: /^[A-Za-z\s]+$/,
                      message:
                        "First Name should contain only letters and spaces",
                    },
                  })}
                />
                {errors.firstName && (
                  <p class="text-danger">{errors.firstName.message}</p>
                )}
              </div>
              <div className="form-group">
                <label for="lname">Last Name</label>
                <input
                  type="lastName"
                  class="form-control light-bg"
                  id="lastName"
                  {...register("lastName", {
                    required: "Last Name is required",
                    pattern: {
                      value: /^[A-Za-z\s]+$/,
                      message:
                        "Last Name should contain only letters and spaces",
                    },
                  })}
                />
                {errors.lastName && (
                  <p class="text-danger">{errors.lastName.message}</p>
                )}
              </div>
              <div className="form-group">
                <label for="email">Email</label>
                <input
                  type="email"
                  class="form-control light-bg"
                  id="email"
                  {...register("email", {
                    required: "User Email is required.",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Please enter a valid email address",
                    },
                  })}
                />
                {errors.email && (
                  <p class="text-danger">{errors.email.message}</p>
                )}
              </div>
              <div className="form-group">
                <label for="password">Password</label>
                <input
                  type="password"
                  class="form-control light-bg"
                  id="password"
                  {...register("password", {
                    required: "User Password is required.",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters long",
                    },
                  })}
                />
                {errors.password && (
                  <p class="text-danger">{errors.password.message}</p>
                )}
              </div>
              <div className="links-area mt-3">
                <span>Do you have an accout? </span>
                <Link to="/">Login in</Link>
              </div>
              <div className="buttons-area mt-4">
                <button type="submit" className="btn btn-danger btn-rounded px-3 py-2">
                  Register
                </button>
                <button className="btn btn-success btn-rounded px-3 py-2 mx-2">
                  Clear
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
